import { fork } from 'redux-saga/effects';
// import cartFetchSaga from './fetch-saga';
import VoucherCartApi from 'Cart/interfaces/voucherApi';
import voucherCartFetchSaga from './fetch-saga';

export default function* vouhcerCartSaga(api: VoucherCartApi) {
  // order of the forked sub-sagas doesn't matter
  yield fork(voucherCartFetchSaga, api);
}
